import MenuFrame from "../frames/menu_frame";

function InsuranceEdit() {
    return (
        <MenuFrame>
            Insurance Edit
        </MenuFrame>
    );
}

export default InsuranceEdit;
